import logoClaro from '@components/Companies/assets/Logo-Claro.png';
import logoCoca from '@components/Companies/assets/Logo-Coca.png';
import logoGlobo from '@components/Companies/assets/Logo-Globo.png';
import logoHp from '@components/Companies/assets/Logo-HP.png';
import logoPositivo from '@components/Companies/assets/Logo-Positivo.png';

export const DEFAULT_PARTNERS = [
  { id: 'claro', src: logoClaro, alt: 'Logo Claro' },
  { id: 'coca', src: logoCoca, alt: 'Logo Coca-Cola' },
  { id: 'globo', src: logoGlobo, alt: 'Logo Globo' },
  { id: 'hp', src: logoHp, alt: 'Logo HP' },
  { id: 'positivo', src: logoPositivo, alt: 'Logo Positivo Tecnologia' },
  { id: 'claro1', src: logoClaro, alt: 'Logo Claro' },
  { id: 'coca1', src: logoCoca, alt: 'Logo Coca-Cola' },
  { id: 'globo1', src: logoGlobo, alt: 'Logo Globo' },
];
